module.exports = __webpack_public_path__ + "img/27a168e.png";